<template>
  <v-app id="inspire">
    <!-- HEADER BAR START-->
    <v-app-bar app clipped-left>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>Brief Builder</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-col class="text-right">
          <v-btn text v-on:click.prevent="zoomLevel += 1">
            <v-icon>mdi-magnify-plus-outline</v-icon>
          </v-btn>
          <v-btn text v-on:click.prevent="zoomLevel -= 1">
            <v-icon>mdi-magnify-minus-outline</v-icon>
          </v-btn>
      </v-col>
    </v-app-bar>
    <!-- HEADER BAR END -->

    <!-- SIDEBAR START -->
    <v-navigation-drawer v-model="drawer" app clipped width="384px">
      <v-col class="d-flex" cols="12">
        
      </v-col>
      <v-list dense>
        
      </v-list>
    </v-navigation-drawer>
    <!-- SIDEBAR END -->

    <v-content>
      <v-container fluid fill-height>
      
        <v-layout justify-center>
          <v-col class="d-flex flex-column" :cols="zoomLevel">
            <!-- PAGE START -->
            <div class="text-center my-10">
              <h2>The Market</h2>
              <h3>Enter Your Competition</h3>
            </div>

            <div style="max-width:600px; width:100%;" class="text-center align-self-center">
              <form v-on:submit.prevent="newCompetitor()">
                <v-text-field label="Enter the web address of your competitors (https://…)" background-color="grey lighten-2" v-model="enteredURL" height="64px">
                </v-text-field>
              </form>
            </div>

            
            <v-row>
            <v-col cols="3" v-for="(competitor, index) in competitors" :key="competitor.url">
            <v-card>
              <div class="img-holder" style="max-height:280px; overflow:hidden;">
                <img width="100%" :src="competitor.imgURI" alt="">
              </div>
              <v-card-text class="text--primary d-flex">
                <div class="align-self-center">{{competitor.url}}</div>
                <v-btn color="grey" class="white--text ml-auto" v-on:click.prevent="deleteObject(index)" icon>
                    <v-icon>mdi-delete</v-icon>
                </v-btn>
              </v-card-text>
            </v-card>
            </v-col>
            </v-row>
            
            </v-col>
        </v-layout>
      </v-container>
    </v-content>

    <!-- FOOTER START -->
    <v-footer app>
          <v-btn color="grey" class="white--text mr-4 mr-auto" large link to="/2">
            <v-icon>mdi-arrow</v-icon>
            Back
          </v-btn>
          <v-btn color="grey" class="white--text mr-4 ml-auto" large link to="/">
            <v-icon>mdi-arrow</v-icon>
            Next
          </v-btn>
    </v-footer>
    <!-- FOOTER END -->

  </v-app>
</template>

<style>
</style>

<script>
export default {
  name: 'MarketCompetition',
  components: {
  },
  data: () => ({
    drawer: closed,
    zoomLevel: 10,
    enteredURL:"",
    competitors: [{
      url:"http://google.com",
      imgURI:`https://api.apiflash.com/v1/urltoimage?access_key=ac4a6409e41e403a978d6d83fa3bd7c2&width=1440&full_page=true&thumbnail_width=500&url=http%3A%2F%2Fgoogle.com`
    }],   
  }),
  mounted() {
    //  LOAD LOCAL STORAGE
     if (localStorage.getItem('localCompetitors')) {
      try {
        this.competitors = JSON.parse(localStorage.getItem('localCompetitors'));
      } catch(e) {
        localStorage.removeItem('localCompetitors');
      }
    }
   },
  methods: {  
    newCompetitor: function() {
        this.competitors.push({url: this.enteredURL, imgURI: `https://api.apiflash.com/v1/urltoimage?access_key=ac4a6409e41e403a978d6d83fa3bd7c2&width=1440&full_page=true&thumbnail_width=500&url=http%3A%2F%2F`+this.enteredURL});
        // enteredURL= "";
        this.saveCompetitors();
    },
    deleteObject: function(index) {
      this.$delete(this.competitors, index);
      this.saveCompetitors();
    },
    saveCompetitors: function() {
      const parsed = JSON.stringify(this.competitors);
      localStorage.setItem('localCompetitors', parsed);
      // console.log("BRIEF BUILDER - Saved to local storage.");
    }
  }
}
</script>
